import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundPageComponent } from '@shared/components/not-found-page/not-found-page.component';
import { ServerErrorPageComponent } from '@shared/components/server-error-page/server-error-page.component';
import { authGuard } from '@shared/services/auth.guard';
import { AuthModule } from './modules/auth/auth.module';
import { LoginModule } from './modules/login/login.module';
import { MonitorModule } from './modules/monitor/monitor.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => AuthModule,
    canActivateChild: [authGuard],
  },
  {
    path: 'login',
    loadChildren: () => LoginModule,
  },
  {
    path: 'monitor',
    loadChildren: () => MonitorModule,
  },
  { path: 'server-error', component: ServerErrorPageComponent },
  { path: 'not-found', component: NotFoundPageComponent },
  { path: '**', redirectTo: '/not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
